import { render, staticRenderFns } from "./content-copy.vue?vue&type=template&id=b8581c0c"
import script from "./content-copy.vue?vue&type=script&lang=js"
export * from "./content-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports